<template>
  <div class="footer py-12">
    <v-container>
      <v-row>
        <!-- SPIL Headline -->
        <v-col cols="12" lg="5" class="d-sm-flex justify-center mb-6">
          <div class="d-flex headline w-100" style="max-width: 610px">
            <img
              src="@/assets/spil_logo.svg"
              alt="shipping, shiplog, logistik, cargo, ekspedisi, kontainer, freight, SPIL"
              class="mr-8 logo"
              loading="lazy"
              decoding="async"
            />

            <div>
              <div class="text-white text-h5">
                PT Salam Pacific Indonesia Lines
              </div>
              <div class="text-white text-h6 mt-6 d-none d-sm-flex">
                SPIL Customer Service
              </div>
              <div
                class="text-white text-body-2 font-weight-medium mt-4 d-none d-sm-flex"
              >
                Call : 081-163-3388 | Whatsapp : 081-133-3799
              </div>
            </div>
          </div>

          <div class="d-block d-sm-none">
            <div class="text-white text-h6 mt-6">SPIL Customer Service</div>
            <div class="text-white text-body-2 font-weight-medium mt-4">
              Call : 081-163-3388 | Whatsapp : 081-133-3799
            </div>
          </div>
        </v-col>

        <!-- Menu List -->
        <v-col cols="12" sm="6" lg="3">
          <div
            v-for="(menu, idx) in footerMenus"
            :key="idx"
            class="mb-4 d-inline-block w-50"
          >
            <router-link
              v-if="!menu?.external"
              :to="menu.href[currLang]"
              @click="setActivePage(menu.href[currLang])"
              class="text-decoration-none text-white text-body-2 font-weight-medium pr-2"
            >
              {{ lang(menu.label) }}
            </router-link>

            <a
              v-else
              :href="menu.href[currLang]"
              target="_blank"
              class="text-decoration-none text-white text-body-2 font-weight-medium pr-2"
              @click="
                () => {
                  const params = {
                    action: `CLICK ${lang(menu.label).toUpperCase()}`,
                    remark: `Click the ${lang(
                      menu.label
                    ).toLowerCase()} menu in the footer`,
                    val1: null,
                    val2: null,
                    val3: null,
                    val4: null,
                    val5: null,
                  };

                  saveTrackAnalytics(params);
                }
              "
            >
              {{ lang(menu.label) }}
            </a>
          </div>
        </v-col>

        <!-- CTA -->
        <v-col class="text-center">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              lg="5"
              class="d-flex justify-space-around d-sm-block"
            >
              <div v-for="(store, idx) in appsStore" :key="idx">
                <a
                  :href="store.link"
                  target="_blank"
                  class="text-decoration-none"
                  @click="
                    () => {
                      const params = {
                        action: 'CLICK CTA',
                        remark: `Click ${store.label} Button`,
                        val1: store.link,
                        val2: null,
                        val3: null,
                        val4: null,
                        val5: null,
                      };

                      saveTrackAnalytics(params);
                    }
                  "
                >
                  <img
                    :src="store.img"
                    :alt="store.alt"
                    width="140"
                    height="auto"
                    class="mb-sm-4"
                    style="aspect-ratio: 3"
                  />
                </a>
              </div>
            </v-col>

            <!-- FOR SM BELOW -->
            <v-col
              cols="12"
              sm="6"
              lg="7"
              class="d-flex d-sm-none justify-space-around"
            >
              <div v-for="(media, idx) in socialMedias" :key="idx">
                <a
                  :href="media.link"
                  target="_blank"
                  class="text-decoration-none"
                  @click="
                    () => {
                      const params = {
                        action: 'CLICK SOCIAL MEDIA',
                        remark: `Click SPIL ${media.label} Button`,
                        val1: media.link,
                        val2: null,
                        val3: null,
                        val4: null,
                        val5: null,
                      };

                      saveTrackAnalytics(params);
                    }
                  "
                >
                  <img
                    :src="media.img"
                    :alt="media.alt"
                    width="48"
                    height="auto"
                    class="m-2"
                    style="aspect-ratio: 1"
                  />
                </a>
              </div>
            </v-col>

            <!-- FOR SM ABOVE -->
            <v-col cols="12" sm="6" lg="7" class="d-none d-sm-block">
              <div class="mb-4">
                <a
                  :href="socialMedias[0].link"
                  target="_blank"
                  class="text-decoration-none"
                  @click="
                    () => {
                      const params = {
                        action: 'CLICK SOCIAL MEDIA',
                        remark: `Click SPIL ${socialMedias[0].label} Button`,
                        val1: socialMedias[0].link,
                        val2: null,
                        val3: null,
                        val4: null,
                        val5: null,
                      };

                      saveTrackAnalytics(params);
                    }
                  "
                >
                  <img
                    :src="socialMedias[0].img"
                    :alt="socialMedias[0].alt"
                    width="48"
                    height="auto"
                    class="mx-2"
                    style="aspect-ratio: 1"
                  />
                </a>
                <a
                  :href="socialMedias[1].link"
                  target="_blank"
                  class="text-decoration-none"
                  @click="
                    () => {
                      const params = {
                        action: 'CLICK SOCIAL MEDIA',
                        remark: `Click SPIL ${socialMedias[1].label} Button`,
                        val1: socialMedias[1].link,
                        val2: null,
                        val3: null,
                        val4: null,
                        val5: null,
                      };

                      saveTrackAnalytics(params);
                    }
                  "
                >
                  <img
                    :src="socialMedias[1].img"
                    :alt="socialMedias[1].alt"
                    width="48"
                    height="auto"
                    class="mx-2"
                    style="aspect-ratio: 1"
                  />
                </a>
              </div>

              <div>
                <a
                  :href="socialMedias[2].link"
                  target="_blank"
                  class="text-decoration-none"
                  @click="
                    () => {
                      const params = {
                        action: 'CLICK SOCIAL MEDIA',
                        remark: `Click SPIL ${socialMedias[2].label} Button`,
                        val1: socialMedias[2].link,
                        val2: null,
                        val3: null,
                        val4: null,
                        val5: null,
                      };

                      saveTrackAnalytics(params);
                    }
                  "
                >
                  <img
                    :src="socialMedias[2].img"
                    :alt="socialMedias[2].alt"
                    width="48"
                    height="auto"
                    class="mx-2"
                    style="aspect-ratio: 1"
                  />
                </a>
                <a
                  :href="socialMedias[3].link"
                  target="_blank"
                  class="text-decoration-none"
                  @click="
                    () => {
                      const params = {
                        action: 'CLICK SOCIAL MEDIA',
                        remark: `Click SPIL ${socialMedias[3].label} Button`,
                        val1: socialMedias[3].link,
                        val2: null,
                        val3: null,
                        val4: null,
                        val5: null,
                      };

                      saveTrackAnalytics(params);
                    }
                  "
                >
                  <img
                    :src="socialMedias[3].img"
                    :alt="socialMedias[3].alt"
                    width="48"
                    height="auto"
                    class="mx-2"
                    style="aspect-ratio: 1"
                  />
                </a>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Copy Right -->
      <div
        class="w-100 text-center text-white text-body-2 font-weight-medium mt-6"
      >
        © {{ currentYear }} PT SALAM PACIFIC INDONESIA LINES. All rights reserved
      </div>
    </v-container>
  </div>
</template>

<script>
import GooglePlay from "@/assets/images/icons/downloadBadge_Googleplay.svg";
import AppStore from "@/assets/images/icons/downloadBadge_Appstore.svg";

import Facebook from "@/assets/images/icons/Icon_Facebook_White.svg";
import LinkedIn from "@/assets/images/icons/Icon_LinkedIn_White.svg";
import Instagram from "@/assets/images/icons/Icon_Instagram_White.svg";
import Youtube from "@/assets/images/icons/Icon_Youtube_White.svg";

import { mapActions } from "pinia";
import { useGeneralStore } from "@/stores/GeneralStore";
import { useTrackAnalyticsStore } from "@/stores/TrackAnalyticsStore";

export default {
  name: "Footer",
  components: {},
  data() {
    return {
      footerMenus: [
        {
          label: "navAbout",
          href: { ind: "/id/tentang-spil", eng: "/en/about-spil" },
        },
        {
          label: "navNews",
          href: { ind: "/id/berita", eng: "/en/news" },
        },
        {
          label: "navMySpil",
          href: { ind: "/id/myspil", eng: "/en/myspil" },
        },
        {
          label: "navCareer",
          href: { ind: "/id/karir", eng: "/en/careers" },
        },
        {
          label: "navSpilDex",
          href: { ind: "/id/spildex", eng: "/en/spildex" },
        },
        {
          external: "true",
          label: "navIntern",
          href: {
            ind: "https://www.spiluniversity.co.id/internship",
            eng: "https://www.spiluniversity.co.id/internship",
          },
        },
        {
          label: "navOutlook",
          href: { ind: "/id/wawasan", eng: "/en/insight" },
        },
        {
          label: "navContact",
          href: { ind: "/id/kontak", eng: "/en/contact" },
        },
        {
          label: "navGroup",
          href: { ind: "/id/perusahaan/grup", eng: "/en/company/group" },
        },
        {
          external: "true",
          label: "navSitemap",
          href: {
            ind: "https://www.spil.co.id/sitemap",
            eng: "https://www.spil.co.id/sitemap",
          },
        },
      ],
      appsStore: [
        {
          img: GooglePlay,
          alt: "shipping, shiplog, logistik, cargo, ekspedisi, kontainer, freight, SPIL",
          link: "https://play.google.com/store/search?q=myspil+reloaded&c=apps",
          label: "Google Play",
        },
        {
          img: AppStore,
          alt: "shipping, shiplog, logistik, cargo, ekspedisi, kontainer, freight, SPIL",
          link: "https://apps.apple.com/id/app/myspil-reloaded/id6446185688?l=id",
          label: "Apps Store",
        },
      ],

      socialMedias: [
        {
          img: Facebook,
          alt: "shipping, shiplog, logistik, cargo, ekspedisi, kontainer, freight, SPIL",
          link: "https://www.facebook.com/ptspil/",
          label: "Facebook",
        },
        {
          img: LinkedIn,
          alt: "shipping, shiplog, logistik, cargo, ekspedisi, kontainer, freight, SPIL",
          link: "https://www.linkedin.com/company/pt-salam-pacific-indonesia-lines/",
          label: "Linkedin",
        },
        {
          img: Instagram,
          alt: "shipping, shiplog, logistik, cargo, ekspedisi, kontainer, freight, SPIL",
          link: "https://www.instagram.com/ptspil/",
          label: "Instagram",
        },
        {
          img: Youtube,
          alt: "shipping, shiplog, logistik, cargo, ekspedisi, kontainer, freight, SPIL",
          link: "https://www.youtube.com/channel/UCXWGx_dFWjhLVG8x85xNpCA",
          label: "Youtube",
        },
      ],
    };
  },
  methods: {
    ...mapActions(useGeneralStore, ["setActivePage"]),
    ...mapActions(useTrackAnalyticsStore, ["saveTrackAnalytics"]),
  },
  computed: {
    currLang() {
      return isIndonesia() ? "ind" : "eng";
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
img {
  cursor: pointer;
}
.logo {
  width: 96px;
  height: 64px;
  transform: translateY(-20%);
}
.footer {
  background: linear-gradient(83deg, #3a9542 -12.59%, #2a695b 162.84%);
}

@media screen and (max-width: 600px) {
  .logo {
    width: 73px;
    height: 48px;
    transform: translateY(0%);
  }
  .text-h5 {
    font-size: 1.3rem !important;
    line-height: 1.8rem;
  }
  .text-h6 {
    font-size: 1rem !important;
    line-height: 1.5rem;
  }
  .text-body-2 {
    font-size: 1rem !important;
    line-height: 1.4rem;
  }
  .headline {
    align-items: center;
  }
}
</style>
